import React, { useState } from "react";
const DropdownComponent = ({
  setsummaryEndMonth,
  setsummaryStartMonth,
  setsummaryStartYear,
  setsummaryEndYear,
  setRegion,
  setTechnology,
  summaryStartMonth,
  summaryEndMonth,
  summaryStartYear,
  summaryEndYear,
  region,
  technology,
}) => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "row",
      gap: "20px",
      flexWrap: "wrap",
    },
    dropdownContainer: {
      marginBottom: "8px",
      display: "flex",
      flexDirection: "column",
    },
    label: {
      marginBottom: "8px",
      fontWeight: "bold",
    },
    select: {
      width: "150px",
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
    },
  };

  const [regionSelected, setRegionSelected] = useState(region || "");
  const [technologySelected, setTechnologySelected] = useState(technology || "");

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const years = Array.from({ length: 15 }, (_, i) => 2020 + i); // 2000–2029

  // ✅ Filtered years for end date
  const filteredEndYears = summaryStartYear
    ? years.filter((year) => year >= summaryStartYear)
    : years;


    const filteredEndMonths = summaryStartYear && summaryEndYear
    ? summaryStartYear === summaryEndYear
      ? months// same year → only months >= startMonth
      : months // different year → allow all months
    : months;

    



  
  return (
    <div style={styles.container}>

        {/* Start Year */}
        <div style={styles.dropdownContainer}>
        <label style={styles.label}>Start Year</label>
        <select
          style={styles.select}
          value={summaryStartYear}
          onChange={(e) => setsummaryStartYear(e.target.value)}
        >
          <option value="">Select Year</option>
          {years.map((year, index) => (
            <option key={index} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      {/* Start Month */}
      <div style={styles.dropdownContainer}>
        <label style={styles.label}>Start Month</label>
        <select
          style={styles.select}
          value={summaryStartMonth}
          onChange={(e) => setsummaryStartMonth(e.target.value)}
          disabled={!summaryStartYear}
        >
          <option value="">Select Month</option>
          {months.map((month, index) => (
            <option key={index} value={month}>
              {month}
            </option>
          ))}
        </select>
      </div>

    

     

      {/* End Year */}
      <div style={styles.dropdownContainer}>
        <label style={styles.label}>End Year</label>
        <select
          style={styles.select}
          value={summaryEndYear}
          onChange={(e) => setsummaryEndYear(e.target.value)}
          disabled={!summaryStartMonth}
        >
          <option value="">Select Year</option>
          {filteredEndYears.map((year, index) => (
            <option key={index} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

       {/* End Month */}
       <div style={styles.dropdownContainer}>
        <label style={styles.label}>End Month</label>
        <select
          style={styles.select}
          value={summaryEndMonth}
          onChange={(e) => setsummaryEndMonth(e.target.value)}
          disabled={!summaryEndYear}
        >
          <option value="">Select Month</option>
          {filteredEndMonths.map((month, index) => (
            <option key={index} value={month}>
              {month}
            </option>
          ))}
        </select>
      </div>

      {/* Region */}
      <div style={styles.dropdownContainer}>
        <label style={styles.label}>Region</label>

        <select
          style={styles.select}
          value={regionSelected}
          onChange={(e) => {
            setRegionSelected(e.target.value);
            setRegion(e.target.value);
          }}
          disabled={!summaryEndMonth}
        >
          <option value="" disabled>
            Select Region
          </option>
          {["France"].map((region, index) => (
            <option value={region} key={index}>
              {region}
            </option>
          ))}
        </select>
      </div>

      {/* Technology */}
      <div style={styles.dropdownContainer}>
        <label style={styles.label}>Technology</label>
        <select
          style={styles.select}
          value={technologySelected}
          onChange={(e) => {
            setTechnologySelected(e.target.value);
            setTechnology(e.target.value);
          }}
          disabled={!region}
        >
          <option value="" disabled>
            Select Technology
          </option>
          {[
            'FWA',
          ].map((geography, index) => (
            <option value={geography} key={index}>
              {geography}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DropdownComponent;
